import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { removeOutline } from "./../../core";
export var NormalizedButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  background-color: transparent;\n  border: none;\n  border-color: transparent;\n  box-sizing: border-box;\n  margin: 0;\n\n  & > div,\n  & > span,\n  & > svg,\n  ::after,\n  ::before {\n    position: relative;\n  }\n"])), function (_ref) {
  var showOutline = _ref.showOutline;
  return !showOutline && removeOutline;
});